import React from 'react';
import { Check } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function Stepper({ active }: { active: number }): React.ReactElement {
  const { t } = useTranslation();
  const steps = [t("checkout.steps.selectPlan"), t("checkout.steps.addPayroll"), t("checkout.steps.createAccount")];
  return (
    <div className="mb-10 flex flex-wrap items-center justify-center gap-3">
      {steps.map((label, i) => {
        const n = i + 1;
        const isActive = n === active;
        const isDone = n < active;
        return (
          <React.Fragment key={i}>
            <div className="flex items-center gap-2">
              <div className={"flex h-8 w-8 items-center justify-center rounded-full text-small font-bold " + (isActive || isDone ? "border-2 border-brand bg-brand text-white" : "border-2 border-hairline bg-white text-muted")}>
                {isDone ? <Check size={16} strokeWidth={3} /> : n}
              </div>
              <span className={"text-small " + (isActive ? "font-bold text-ink" : "font-medium text-sub")}>{label}</span>
            </div>
            {i < steps.length - 1 && <div className="h-0.5 w-10 rounded bg-hairline" />}
          </React.Fragment>
        );
      })}
    </div>
  );
}
